import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
// import AuthGuard from 'src/utils/auth-guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/dashboard'));
const CasinoPage = lazy(() => import('src/pages/dashboard/casino'));
const LiveCasinoPage = lazy(() => import('src/pages/dashboard/live-casino'));
const GamePage = lazy(() => import('src/pages/dashboard/game'));
// const PageFour = lazy(() => import('src/pages/dashboard/four'));
// const PageFive = lazy(() => import('src/pages/dashboard/five'));
// const PageSix = lazy(() => import('src/pages/dashboard/six'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'casino', element: <CasinoPage /> },
      { path: 'live-casino', element: <LiveCasinoPage /> },
      { path: 'game', element: <GamePage /> },
      // {
      //   path: 'group',
      //   children: [
      //     { element: <PageFour />, index: true },
      //     { path: 'five', element: <PageFive /> },
      //     { path: 'six', element: <PageSix /> },
      //   ],
      // },
    ],
  },
];
